import { VariableModel } from '@/lib/model';
import * as React from 'react';
import './index.scss';

export const Variable: React.FC<VariableModel & { fillColor: string }> = ({
  label,
  description,
  frontBarLabel,
  frontBarPercentage,
  backBarLabel,
  backBarPercentage,
  fillColor,
}) => (
  <div className="Variable">
    <div className="Variable__bars">
      <div
        className="Variable__bars__front"
        style={{ height: `${frontBarPercentage}%`, backgroundColor: fillColor }}
      >
        <span>{frontBarLabel}</span>
      </div>
      <div
        className="Variable__bars__back"
        style={{ height: `${backBarPercentage}%` }}
      >
        <span>{backBarLabel}</span>
      </div>
    </div>
    <div>
      <span className="Variable__label">{label}</span>
      <span className="Variable__desc">{description}</span>
    </div>
  </div>
);
